// Four separate blur surfaces leave the real target completely unobscured.
// A transparent ring alone cannot undo a full-viewport backdrop-filter.
export const TourSpotlight = ({rect, viewport, onDismiss}) => {
  const {width, height} = viewport;
  const padding = 8;
  const left = rect ? Math.max(0, Math.min(width, rect.left - padding)) : 0;
  const top = rect ? Math.max(0, Math.min(height, rect.top - padding)) : 0;
  const right = rect ? Math.max(left, Math.min(width, rect.left + rect.width + padding)) : 0;
  const bottom = rect ? Math.max(top, Math.min(height, rect.top + rect.height + padding)) : 0;
  const panels = rect ? [
    ['top', {left:0, top:0, width, height:top}],
    ['left', {left:0, top, width:left, height:bottom-top}],
    ['right', {left:right, top, width:width-right, height:bottom-top}],
    ['bottom', {left:0, top:bottom, width, height:height-bottom}],
  ] : [['full', {left:0, top:0, width, height}]];
  return <>
    <div className="fixed inset-0 z-[9998]" onClick={onDismiss} data-testid="tour-backdrop" aria-hidden="true">
      {panels.map(([name, style]) => <div key={name} data-testid={`tour-backdrop-${name}`} className="absolute bg-black/40 backdrop-blur-[2px]" style={style}/>)}
    </div>
    {rect && <div data-testid="tour-highlight" className="fixed z-[9999] pointer-events-none rounded-sm" aria-hidden="true" style={{
      top:rect.top-4, left:rect.left-4, width:rect.width+8, height:rect.height+8,
      border:'2px solid #059669',
    }}/>} 
  </>;
};
